/**
 * @param {String} testName
 * @param {String} testVariant
 * @return {Object} a set of things to be applied as React component props
 */
function calculateDefaultProps(testName, testVariant) {
    return {};
}

export {
    calculateDefaultProps,
};
